import { ref as storageRef, deleteObject, listAll } from "firebase/storage";
import { cloudstore } from "../api/firebase";

export const getFileListing = async (): Promise<Record<string, string[]>> => {
  const directory_listing: Record<string, string[]> = {};
  const res = await listAll(storageRef(cloudstore, "userdata"));
  for (const folderRef of res.prefixes) {
    const folderRes = await listAll(folderRef);
    const user = folderRef.fullPath.substring(9);
    directory_listing[user] = [];
    folderRes.items.forEach((itemRef) => {
      directory_listing[user].push(itemRef.fullPath);
    });
  }
  return directory_listing;
};

export const deleteFileFromURI = async (uri: string): Promise<void> => {
  const reference = storageRef(cloudstore, uri);
  deleteObject(reference).catch((error) => {
    console.error(error);
  });
};

export const deleteFile = async (file: string): Promise<void> => {
  const fileRef = storageRef(cloudstore, file);
  deleteObject(fileRef).catch((error) => {
    console.error(error);
  });
};
